<ni-card [headerBgColor]="'gray'" title="Your Top Customers">
    <div class="flex">
        <div class="d-inline-block mr-2 ml-2">
            <app-preset-date-filter
                [defaultFilter]="selectedFilter"
                (selectedFilterChange)="applyPresetDateFilter($event)"
            ></app-preset-date-filter>
        </div>
        <div>
            <div class="d-inline-block mr-2 ml-2" style="width: 130px">
                <mat-form-field>
                    <input
                        (dateChange)="applyCustomDateFilter()"
                        (focus)="dashboardSettingsStartDateFilter.open()"
                        [(ngModel)]="filterStartDate"
                        [matDatepicker]="dashboardSettingsStartDateFilter"
                        [max]="filterEndDate"
                        matInput
                        placeholder="Start Date"
                    />
                    <mat-datepicker-toggle
                        [for]="dashboardSettingsStartDateFilter"
                        matSuffix
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                        #dashboardSettingsStartDateFilter
                        disabled="false"
                    ></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="d-inline-block mr-2 ml-2" style="width: 130px">
                <mat-form-field>
                    <input
                        (dateChange)="applyCustomDateFilter()"
                        (focus)="dashboardSettingsEndDateFilter.open()"
                        [(ngModel)]="filterEndDate"
                        [matDatepicker]="dashboardSettingsEndDateFilter"
                        [min]="filterStartDate"
                        matInput
                        placeholder="End Date"
                    />
                    <mat-datepicker-toggle
                        [for]="dashboardSettingsEndDateFilter"
                        matSuffix
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                        #dashboardSettingsEndDateFilter
                        disabled="false"
                    ></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="chart-container">
        <ngx-charts-pie-chart
            *ngIf="totalOrdersData"
            [gradient]="false"
            [labels]="true"
            [results]="totalOrdersData"
            [scheme]="colorScheme"
            [trimLabels]="false"
        ></ngx-charts-pie-chart>
    </div>
    <mat-button-toggle-group
        (change)="changeType($event)"
        appearance="legacy"
        class="chart-type-toggle d-none"
        value="order"
    >
        <mat-button-toggle value="order">Orders</mat-button-toggle>
        <mat-button-toggle value="volume">Volume</mat-button-toggle>
    </mat-button-toggle-group>
    <ngx-ui-loader
        [loaderId]="chartName"
        bgsColor="rgb(100, 181, 246)"
        bgsPosition="center-center"
        bgsType="ball-spin"
        overlayColor="rgba(0, 0, 0, 0.1)"
    ></ngx-ui-loader>
</ni-card>
